import { Card, CardContent } from "@/components/ui/card";

export default function Helpdesk() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-servify-purple/5 via-white to-servify-purple/5 p-6">
      <div className="max-w-4xl mx-auto space-y-8">
        {/* Header */}
        <div className="text-left space-y-4">
          <h1 className="text-4xl font-bold text-servify-dark-grey">Helpdesk Guide</h1>
          <p className="text-xl text-servify-dark-grey/70 max-w-3xl">
            Here's a quick and easy guide to our Servify Apps Helpdesk — so you know exactly whom to reach out to.
          </p>
        </div>

        {/* Support Card */}
        <div className="max-w-2xl mx-auto">
          <Card className="border-servify-white-grey shadow-lg">
            <CardContent className="p-4 space-y-2">
              <div className="bg-gray-50 rounded-lg p-2 flex justify-between items-center">
                <span className="text-servify-dark-grey font-medium">ADP</span>
                <a 
                  href="mailto:amit.a@servify.com" 
                  className="text-servify-purple hover:underline font-medium"
                >
                  amit.a@servify.com
                </a>
              </div>
              <div className="bg-gray-50 rounded-lg p-2 flex justify-between items-center">
                <span className="text-servify-dark-grey font-medium">Jira</span>
                <a 
                  href="mailto:sekhar.n@servify.com" 
                  className="text-servify-purple hover:underline font-medium"
                >
                  sekhar.n@servify.com
                </a>
              </div>
              <div className="bg-gray-50 rounded-lg p-2 flex justify-between items-center">
                <span className="text-servify-dark-grey font-medium">KnowBe4</span>
                <a 
                  href="mailto:rochelle.x@servify.com" 
                  className="text-servify-purple hover:underline font-medium"
                >
                  rochelle.x@servify.com
                </a>
              </div>
              <div className="bg-gray-50 rounded-lg p-2 flex justify-between items-center">
                <span className="text-servify-dark-grey font-medium">Oracle HCM</span>
                <a 
                  href="mailto:hr@servify.com" 
                  className="text-servify-purple hover:underline font-medium"
                >
                  hr@servify.com
                </a>
              </div>
              <div className="bg-gray-50 rounded-lg p-2 flex justify-between items-center">
                <span className="text-servify-dark-grey font-medium">Servify Help Center</span>
                <a 
                  href="https://helpcenter.servify.com/portal/en/home" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-servify-purple hover:underline font-medium"
                >
                  helpcenter.servify.com
                </a>
              </div>
              <div className="bg-gray-50 rounded-lg p-2 flex justify-between items-center">
                <span className="text-servify-dark-grey font-medium">IT Helpdesk</span>
                <a 
                  href="mailto:it_helpdesk@servify.com" 
                  className="text-servify-purple hover:underline font-medium"
                >
                  it_helpdesk@servify.com
                </a>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
